export default "<p class=\"error-text\">\n  Could not load a valid session. Please re-enter from the main PIMA application.\n</p>\n"